import { useFormikContext } from 'formik'

import {
  FormBody,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../../../Form'
import { getRequestProfileWidgetProvidersPermissions } from '../../RequestProfileWidgetProviders.utils'

import { RecommendedProvidersField } from './RecommendedProvidersField'
import { SelectedProvidersField } from './SelectedProvidersField'

import * as styles from './RequestProfileWidgetProvidersFormFields.module.css'

function RequestProfileWidgetProvidersFormFields({
  initialRecommendedProviderId,
  notifications,
  recommendationTooltipKey,
  recommendedProviders,
  requestId,
  requestPermissions,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { dirty, isSubmitting } = useFormikContext()

  const { canViewRecommendedContractors } =
    getRequestProfileWidgetProvidersPermissions(requestPermissions)

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  function handleCancel() {
    onCancel({ dirty })
  }

  return (
    <FormBody
      actionsProps={{
        ButtonAdd: false,
        ButtonClear: false,
        Header: false,
        UploadComponent: false,
        cancelProps: {
          onClick: handleCancel,
        },
        isSubmitting,
        submitProps: {
          isLoading: isSubmitting,
          title: 'Modal.SaveBtnKey',
        },
      }}
    >
      <div className={styles.sections}>
        <FormInlineNotifications notifications={notifications} />
        <SelectedProvidersField requestId={requestId} />
        {canViewRecommendedContractors ? (
          <RecommendedProvidersField
            initialRecommendedProviderId={initialRecommendedProviderId}
            recommendationTooltipKey={recommendationTooltipKey}
            recommendedProviders={recommendedProviders}
            requestPermissions={requestPermissions}
          />
        ) : null}
      </div>
    </FormBody>
  )
}

export default RequestProfileWidgetProvidersFormFields
